import {computed} from 'vue';
import {useTranslation} from '#imports';

export function useLocationHint(firstName: string, location: {city?: string; locationType: string}, targetCity?: string) {
    const {t} = useTranslation();

    const locationHint = computed(() => {
        let tooltip = '';
        if (location.city === targetCity) {
            if (['EXACT', 'NEAR'].includes(location.locationType)) {
                tooltip = t('profile.card.header.location.execute.onsite', [firstName]);
            } else {
                tooltip = t('profile.card.header.location.execute.remotely', [firstName]);
            }
        } else if (targetCity) {
            tooltip = t('profile.card.header.location.go.execute.onsite', [firstName, targetCity]);
        }
        return tooltip;
    });

    return {
        locationHint,
    };
}
